import { render, staticRenderFns } from "./DialogsAndSystemsContent.vue?vue&type=template&id=b121e378&scoped=true&"
import script from "./DialogsAndSystemsContent.vue?vue&type=script&lang=js&"
export * from "./DialogsAndSystemsContent.vue?vue&type=script&lang=js&"
import style0 from "./DialogsAndSystemsContent.vue?vue&type=style&index=0&id=b121e378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b121e378",
  null
  
)

export default component.exports